import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import * as reportApi from "../../../api/reportApi";
import { usePagination, useSortBy, useTable } from "react-table";
import BTable from "react-bootstrap/Table";
import { Accessors, Common } from "../../../helper";
import { reportColunms } from "./reportColumns";
import { Pagination } from "react-bootstrap";
import { styles } from "./reportStyles";
import { isEmptyArray, sortArrayOfObjects } from "../../../util";
import { setPupilSavedReport } from "../../../store/pupilProgressSlice";


const Table = ({ columns, data }) => {
  const { getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize },
  } = useTable({
    columns,
    data,
    initialState: { pageIndex: 0, pageSize: 10 },
  },
  useSortBy,
  usePagination
  );
  return (
    <>
      <BTable striped bordered hover responsive {...getTableProps()}>
        <thead>
          {headerGroups.map((headerGroup, i) => (
            <tr key={i} {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column, i) => (
                <th key={i} {...column.getHeaderProps()}>
                  {column.render("Header")}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.map((row, i) => {
            prepareRow(row);
            return (
              <tr key={i} {...row.getRowProps()}>
                {row.cells.map((cell, i) => {
                  return (
                    <td key={i} {...cell.getCellProps()}>
                      {cell.render("Cell")}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </BTable>
      <div className="d-flex justify-content-end" style={styles.paginate}>
        <span className="d-flex align-items-baseline">
          {Common.RowsPerPage}
          <select
            className="form-control w-auto mx-2"
            value={pageSize}
            onChange={(e) => {
              setPageSize(Number(e.target.value));
            }}
          >
            {[5, 10, 20, 30, 40, 50].map((pageSize) => (
              <option key={pageSize} value={pageSize}>
                {pageSize}
              </option>
            ))}
          </select>
        </span>
        <span
          className="d-flex align-items-center"
          style={{ marginBottom: "13px" }}
        >
          {Common.Page}{" "}
          <strong>
            {" "}
            {pageIndex + 1} of {pageOptions?.length}{" "}
          </strong>{" "}
        </span>

        <Pagination className="justify-content-end">
          <Pagination.First
            onClick={() => gotoPage(0)}
            disabled={!canPreviousPage}
          />
          <Pagination.Prev
            onClick={() => previousPage()}
            disabled={!canPreviousPage}
          />
          <Pagination.Next
            onClick={() => nextPage()}
            disabled={!canNextPage}
          />
          <Pagination.Last
            onClick={() => gotoPage(pageCount - 1)}
            disabled={!canNextPage}
          />
        </Pagination>
      </div></>

  )
}
const SavedReports = (props) => {
  const { setInd } = props
  const dispatch = useDispatch();
  const pupilData = useSelector((state) => state.pupilProgress.pupilInfo);
  const [tableDetails, setTableDetails] = useState([])
  const navigateToProgress = (item) => {
    sessionStorage.setItem("savedReports", JSON.stringify(item))
    dispatch(setPupilSavedReport(item));
    setInd(0);
  }
  const getReportsByPupilId = async () => {
    const reports = await reportApi.getReportsByPupilId({ pupilId: pupilData.id });
    console.log({ reports: reports.Items[reports.Items.length-1].createdAt });
    if (!isEmptyArray(reports.Items)) {
      let responseData = reports.Items.map((item, ind) => ({
        ...item,
        [Accessors.Report]: `Report ${ind + 1}`,
        [Accessors.CreatedAt]: `${showCurrentTimeZoneFormat(item.createdAt)}`,
        [Accessors.UpdatedAt]: `${showCurrentTimeZoneFormat(item.updatedAt)}`,
        [Accessors.View]: <button onClick={() => navigateToProgress({ ...item, reportName: `Report ${ind + 1}` })} className="update-button">{Common.ViewReport}</button>,
        [Accessors.SchoolYear]: `${Common.Year} ${item[Accessors.Year]}`
      }));
      setTableDetails(sortArrayOfObjects(responseData, Common.Updatedat, Common.Descending));
    } else {
      setTableDetails([]);
    }
  }
  const showCurrentTimeZoneFormat = (timeStamp) => {
    const ukDateTimeString = timeStamp;
    const ukDate = new Date(`${ukDateTimeString} GMT+0100`); 
    const localDateTimeString = ukDate.toLocaleString();
    return localDateTimeString 
  }
  useEffect(() => {
    getReportsByPupilId()
  }, [])
  return (
    <div className="SavedReports">
      <div className="mainTargetMainPage">
        {tableDetails.length > 0 ? <Table
          columns={reportColunms}
          data={tableDetails}
        /> : <>{Common.NoDataFound}</>}

      </div>
    </div>
  )
}

export { SavedReports }